import { useMemo } from 'react';
import { BasicFormState } from 'hooks/useForm';
import { AssignmentField } from './types';

const usePersonalTransportCalculatedTimes = (
  state: BasicFormState<AssignmentField>
) => {
  const personalTransportToAssignmentEstimatedStartTime =
    state[AssignmentField.personalTransportationToAssignmentEstimatedStartTime];
  const personalTransportToAssignmentEstimatedDuration =
    state[AssignmentField.personalTransportationToAssignmentEstimatedDuration];

  const personalTransportToAssignmentStartTime = useMemo(() => {
    // if we have a personal transportation to assignment estimated start time, use that
    if (personalTransportToAssignmentEstimatedStartTime) {
      return new Date(personalTransportToAssignmentEstimatedStartTime);
    }
    return null;
  }, [personalTransportToAssignmentEstimatedStartTime]);

  const personalTransportToAssignmentEndTime = useMemo(() => {
    // if we have a personal transportation to assignment estimated duration and start time, use that
    if (
      personalTransportToAssignmentEstimatedStartTime &&
      personalTransportToAssignmentStartTime
    ) {
      const estimatedDuration = Number(
        personalTransportToAssignmentEstimatedDuration
      );
      const result = new Date(
        personalTransportToAssignmentStartTime.getTime() + estimatedDuration
      );

      return result;
    }
    return null;
  }, [
    personalTransportToAssignmentEstimatedDuration,
    personalTransportToAssignmentEstimatedStartTime,
    personalTransportToAssignmentStartTime,
  ]);

  return {
    personalTransportToAssignmentStartTime,
    personalTransportToAssignmentEndTime,
  };
};

export default usePersonalTransportCalculatedTimes;
